export const QUALITY_TIER_ORDER = ['DRAFT', 'PREVIEW', 'HIGH', 'MASTER'];
export const QUALITY_PRESETS = {
    DRAFT: {
        maxParticles: 2000,
        shadows: false,
        postProcessing: false,
        textureScale: 0.25,
        antialiasing: false,
        samples: 1,
        lod: 0,
        bitrate: 2_000_000,
    },
    PREVIEW: {
        maxParticles: 20_000,
        shadows: true,
        postProcessing: true,
        textureScale: 0.5,
        antialiasing: true,
        samples: 2,
        lod: 1,
        bitrate: 8_000_000,
    },
    HIGH: {
        maxParticles: 100_000,
        shadows: true,
        postProcessing: true,
        textureScale: 1,
        antialiasing: true,
        samples: 4,
        lod: 2,
        bitrate: 20_000_000,
    },
    MASTER: {
        maxParticles: 500_000,
        shadows: true,
        postProcessing: true,
        textureScale: 1,
        antialiasing: true,
        samples: 8,
        lod: 3,
        bitrate: 50_000_000,
    },
};
export function getQualitySettings(tier, resolution) {
    return {
        tier,
        resolution,
        ...QUALITY_PRESETS[tier],
    };
}
export function resolveQualityTier(_requested, availableTiers) {
    const available = new Set(availableTiers);
    for (const tier of QUALITY_TIER_ORDER) {
        if (available.has(tier))
            return tier;
    }
    return 'DRAFT';
}
export function tierRank(tier) {
    return QUALITY_TIER_ORDER.indexOf(tier);
}
export function isTierAtLeast(current, minimum) {
    return tierRank(current) >= tierRank(minimum);
}
//# sourceMappingURL=quality.js.map